import { AppDB } from './app-db';

const LANG_IDX = 1;

export type LangEntity = {
  id: number;
  currentLang: 'en' | 'hy' | 'ru';
};

export const getCurrentLang = async (db: AppDB) => {
  // this.db is inherited from Entity<AppDB>:
  try {
    const record = await db.lang.get(LANG_IDX);
    if (!record) return null;

    const lang = record?.currentLang;

    return lang;
  } catch (error) {
    console.log(error);

    return null;
  }
};

export const setCurrentLang = async (
  db: AppDB,
  currentLang: LangEntity['currentLang']
) => {
  try {
    const index = await db.lang.put({ id: LANG_IDX, currentLang });
    return index === LANG_IDX;
  } catch (error) {
    console.log(error);
    return null;
  }
};
